import Vue from "vue";

export default {
    setDealerResults(state, value) {
        Vue.set(state, 'dealerResults', value);
    },
    setMapCenter(state, value) {
        Vue.set(state, 'mapCenter', value)
    },
    setMapZoom(state, value) {
        Vue.set(state, 'zoom', value)
    },
    setUserLocation(state, value) {
        Vue.set(state, 'userLocation', value)
    },
    setAvailableFilters(state, typeFilters) {
        Vue.set(state, 'availableFilters', typeFilters)
    },
    requireEmail(state, value) {
        Vue.set(state, 'requireEmail', !!value)
    },
    setTypeFilter(state, {filterName, selected}) {
        if (state.availableFilters.length) {
            const typeFilters = [...state.availableFilters];

            const index = typeFilters.findIndex(filter => filter.name === filterName)
            typeFilters[index].selected = selected

            Vue.set(state, 'availableFilters', typeFilters)        }
    },
    setCountry(state, country) {
        state.country = country;
        state.city = null
    },
    setCity(state, city) {
        state.city = city
    },
    setRadius(state, radius) {
        Vue.set(state, 'radius', radius)
    }
};
